import { BarChart } from '@mui/x-charts/BarChart';
import ChartCard from '../../analytics/ChartCard';
import { QueryDurationDataPoint } from '../../../../types/admin';

interface DatabaseQueryChartProps {
  data: QueryDurationDataPoint[];
  loading?: boolean;
}

export default function DatabaseQueryChart({ data, loading }: DatabaseQueryChartProps) {
  const labels = data.map((d) => d.duration_bucket);
  const counts = data.map((d) => d.count);

  return (
    <ChartCard
      title="Database Query Duration Distribution"
      subtitle="Query count by duration bucket"
      loading={loading}
      height={400}
    >
      <BarChart
        xAxis={[
          {
            data: labels,
            scaleType: 'band',
          },
        ]}
        yAxis={[
          {
            label: 'Query Count',
          },
        ]}
        series={[
          {
            data: counts,
            label: 'Queries',
            color: '#1976d2',
          },
        ]}
        grid={{ horizontal: true }}
      />
    </ChartCard>
  );
}
